const descriptions = {
  chaptersTitle: {
    id: 'course-authoring.textbooks.chapters.title',
    defaultMessage: '{count} capítulos en PDF',
    description: 'Title for the list of PDF chapters',
  },
  buttonView: {
    id: 'course-authoring.textbooks.button.view',
    defaultMessage: 'Vea el PDF en directo',
    description: 'Text for the button to view the PDF live',
  },
  buttonViewAlt: {
    id: 'course-authoring.textbooks.button.view.alt',
    defaultMessage: 'botón de vista del libro de texto',
    description: 'Alt text for the view button',
  },
  buttonEdit: {
    id: 'course-authoring.textbooks.button.edit',
    defaultMessage: 'Editar',
    description: 'Text for the edit button',
  },
  buttonEditAlt: {
    id: 'course-authoring.textbooks.button.edit.alt',
    defaultMessage: 'botón de edición del libro de texto',
    description: 'Alt text for the edit button',
  },
  buttonDelete: {
    id: 'course-authoring.textbooks.button.delete',
    defaultMessage: 'Eliminar',
    description: 'Text for the delete button',
  },
  buttonDeleteAlt: {
    id: 'course-authoring.textbooks.button.delete.alt',
    defaultMessage: 'botón-eliminar-libro-de-texto',
    description: 'Alt text for the delete button',
  },
  deleteModalTitle: {
    id: 'course-authoring.textbooks.form.delete-modal.title',
    defaultMessage: 'Eliminar “{textbookTitle}”?',
    description: 'Title for the delete modal',
  },
  deleteModalDescription: {
    id: 'course-authoring.textbooks.form.delete-modal.description',
    defaultMessage: 'La eliminación de un libro de texto es irreversible y, una vez eliminado, cualquier referencia al mismo en la navegación del curso también se eliminará.',
    description: 'Description for the delete modal',
  },
};

export default descriptions;
